import qs from 'qs'
import { useLocation } from 'react-router-dom'

export const useUnsubscribeParams = () => {
  const location = useLocation()
  const params = qs.parse(location.search, { ignoreQueryPrefix: true })

  const action = params.action

  if (action !== 'unsubscribe' || !params.notificationChannelId) {
    return null
  }

  const bannerId = params.bannerId
  const notificationChannelId = params.notificationChannelId

  return { bannerId, notificationChannelId }
}
